export default function portfolio() {
  // Elements
  let accordions = document.querySelectorAll('.c-portfolio__accordion');
  let filters = document.querySelector('.c-portfolio__filters');
  let investmentFilters = document.querySelectorAll('.investment-filter button');
  let exitedToggle = document.querySelector('.exited-toggle');
  let searchInput = document.querySelector('.filter-search');
  // Scrolling logic
  let naturalPosition = filters.getBoundingClientRect().top + window.scrollY;
  let lastKnownScrollPosition = 0;
  let ticking = false;

  // Filter Control Object
  const filterControl = {
    investment: {
      active: false,
      selection: null,
    },
    exited: {
      active: false,
    },
    search: {
      active: false,
      term: '',
    },
    updateInvestment(selection) {
      if (selection) {
        this.investment.active = true;
        this.investment.selection = selection;
      } else {
        this.investment.active = false;
        this.investment.selection = null;
      }
      callFilterTransition();
    },
    updateExited() {
      this.exited.active = !this.exited.active;
      callFilterTransition();
    },
    updateSearch(term) {
      this.search.term = term.toLowerCase();

      if (this.search.term != '') {
        this.search.active = true;
      } else {
        this.search.active = false;
      }

      callFilterTransition();
    },
  };

  // Master Filter Logic
  const filterMaster = () => {
    if (filterControl.search.active && filterControl.exited.active && filterControl.investment.active) {
      accordions.forEach((item) => {
        if (item.innerText.toLowerCase().indexOf(filterControl.search.term) > -1 && item.dataset.type === filterControl.investment.selection && item.dataset.active === '0') {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      })
    } else if (filterControl.search.active && filterControl.exited.active) {
      accordions.forEach((item) => {
        if (item.innerText.toLowerCase().indexOf(filterControl.search.term) > -1 && item.dataset.active === '0') {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    } else if (filterControl.search.active && filterControl.investment.active) {
      accordions.forEach((item) => {
        if (item.innerText.toLowerCase().indexOf(filterControl.search.term) > -1 && item.dataset.type === filterControl.investment.selection) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    } else if (filterControl.investment.active && filterControl.exited.active) {
      accordions.forEach((item) => {
        if(item.dataset.type === filterControl.investment.selection && item.dataset.active === '0') {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    } else if (filterControl.investment.active) {
      accordions.forEach((item) => {
        if(item.dataset.type === filterControl.investment.selection && item.dataset.active !== '0') {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    } else if (filterControl.exited.active) {
      accordions.forEach((item) => {
        if(item.dataset.active === '0') {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    } else if (filterControl.search.active) {
      accordions.forEach((item) => {
        if (item.innerText.toLowerCase().indexOf(filterControl.search.term) > -1 && item.dataset.active !== '0') {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });
    } else {
      unshuffle();
    }
  }

  // Utility functions
  const unshuffle = () => {
    accordions.forEach((item) => {
      if (item.dataset.active === '0') {
        item.classList.add('hidden');
      } else {
        item.classList.remove('hidden');
      }
    })
  }

  const removeActive = () => {
    let active = document.querySelectorAll('.filter-active');
    active.forEach((item) => {
      item.classList.remove('filter-active');
    })
  }

  const callFilterTransition = () => {
    if (document.startViewTransition) {
      document.startViewTransition(() => filterMaster());
    } else {
      filterMaster();
    }
  }

  // Portfolio Accordion
  accordions.forEach((accordion) =>{
    let accordionHeader = accordion.querySelector('.c-portfolio__accordion-header');

    accordionHeader.addEventListener('click', (e) => {
      e.preventDefault();
      if (document.startViewTransition) {
        document.startViewTransition(() => accordion.classList.toggle('active'));
      } else {
        accordion.classList.toggle('active');
      }
    });
  });

  // Portfolio Sticky Filters
  document.addEventListener("scroll", () => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (lastKnownScrollPosition >= naturalPosition) {
          filters.classList.add('sticky');
        } else {
          filters.classList.remove('sticky');
        }
        ticking = false;
      });
  
      ticking = true;
    }
  });

  
  // Portfolio Exited Toggle
  exitedToggle.addEventListener('click', (e) => {
    let parent = e.target.closest('.exited-toggle');
    parent.classList.toggle('show-exited');
    
    filterControl.updateExited();
  });

  // Portfolio Filters
  investmentFilters.forEach((filter) => {
    filter.addEventListener('click', (e) => {
      if (e.target.classList.contains('filter-active')) {
        e.target.classList.remove('filter-active');
        filterControl.updateInvestment(null);
      } else {
        removeActive();
        e.target.classList.add('filter-active');
        filterControl.updateInvestment(e.target.dataset.type);
      }
    });
  });

  // Portfolio Search
  searchInput.addEventListener('input', (e) => {
    filterControl.updateSearch(e.target.value);
  });
}


// WEBPACK FOOTER //
// ./scripts/util/portfolio.js